import React from 'react';
import { OrderOverviewContainer } from 'components/order/overview/OrderOverviewContainer';
import { useSetOrderNavigationTab } from '../../utilities/hooks/useSetOrderNavigationTab';
import { OrderTabs } from 'store/order/orderNavigation/orderNavigationSlice';
import { AssociatedLendersProvider } from '../../ui-toolkit/associatedLenders/AssociatedLendersProvider';

export interface IOrderOverviewPageProps {}

export const OrderOverviewPage: React.FC<IOrderOverviewPageProps> = () => {
  useSetOrderNavigationTab({ tab: OrderTabs.Overview });

  return (
    <AssociatedLendersProvider>
      <OrderOverviewContainer />
    </AssociatedLendersProvider>
  );
};
